import { render, staticRenderFns } from "./ActionEditCustomerData.vue?vue&type=template&id=556dbf88&scoped=true&"
import script from "./ActionEditCustomerData.vue?vue&type=script&lang=js&"
export * from "./ActionEditCustomerData.vue?vue&type=script&lang=js&"
import style0 from "./ActionEditCustomerData.vue?vue&type=style&index=0&id=556dbf88&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556dbf88",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
